import { LAYOUTS, } from "@voltmoney/types";
import { WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import { ACTION } from "./types";
import { Done, goBack } from "./action";
import { api } from "../../configs/api";
import SharedPropsService from "../../SharedPropsService";
import { getAppHeader } from "../../configs/config";
export const template = (height, avaialbleCredit) => ({
    layout: {
        id: ROUTE.PHONE_PAY_PAGE,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            { id: "phonePayPage", type: WIDGET.PHONE_PAY_PAGE }
        ],
    },
    datastore: {
        phonePayPage: {
            height: height,
            interestDueAmount: avaialbleCredit,
            contactSupportAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.PHONE_PAY_PAGE,
            },
            backAction: {
                type: ACTION.OPEN_WHATSAPP,
                routeId: ROUTE.PHONE_PAY_PAGE,
            },
        },
    },
});
export const phonePayPage = {
    onLoad: async ({ getHeight, network, instrumentTrack, openNewTab }) => {
        instrumentTrack("PHONEPE_ENDSCREEN_VIEWED");
        let user = await SharedPropsService.getUser();
        const getPledgeDetails = await network.get(`${api.pledgeData}${user.linkedApplications[0].applicationId}`, {
            headers: await getAppHeader()
        });
        const availableCredit = getPledgeDetails.data.stepResponseObject.requestCreditLimit + getPledgeDetails.data.stepResponseObject.approvedCreditLimit;
        return Promise.resolve(template(getHeight(), availableCredit));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.OPEN_WHATSAPP]: Done,
    },
    clearPrevious: true,
};
